import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'
import { patchSessionMainRunInCache } from 'Pods/ThreeDStudio/Shared/Utils/patchSessionMainRunInCache'

const showNotification = (message, type) => {
  if (typeof window !== 'undefined' && window.showNotification) {
    window.showNotification(message, { type, autohide: true })
  }
}

function useUpdateRunPrivacy() {
  const queryClient = useQueryClient()
  const { postData, isLoading } = useApiPost()

  const updateRunPrivacy = useCallback(({ runId, sessionId, isPrivate }) => {
    if (runId == null) {
      return
    }

    postData({
      path: `/api/internal/generator/runs/${runId}/privacy`,
      data: { private: isPrivate },
      onSuccess: () => {
        patchSessionMainRunInCache(queryClient, {
          sessionId,
          transform: (prevMainRun) => ({ ...prevMainRun, private: isPrivate }),
        })
      },
      onError: () => {
        showNotification('Failed to update model privacy. Please try again.', 'error')
      },
    })
  }, [postData, queryClient])

  return { updateRunPrivacy, isLoading }
}

export default useUpdateRunPrivacy
